import type { ChangeEventHandler, CSSProperties, Ref } from 'react';
import classNames from 'classnames';
import map from 'lodash/map';
import * as styles from './Select.module.scss';

interface ListItem {
  id?: string | number;
  value?: string | number;
  name?: string;
  displayName?: string;
}

interface AdminSelectProps {
  name: string;
  label?: string;
  list: ListItem[];
  value?: string | number;
  selectLabel?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  style?: CSSProperties;
  disabled?: boolean;
  error?: string;
  dataRecurly?: string;
  selectClassName?: string;
  containerClassname?: string;
  ref?: Ref<HTMLSelectElement>;
}

const AdminSelect = ({
  name,
  label,
  list,
  value,
  selectLabel,
  onChange,
  style,
  disabled,
  error,
  dataRecurly,
  selectClassName,
  containerClassname,
  ref,
}: AdminSelectProps) => {
  return (
    <div className={classNames(styles.container, containerClassname)} style={style}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
      <select
        id={name}
        className={classNames(styles.select, selectClassName, { [styles.error]: error })}
        name={name}
        value={value}
        onChange={(e) => {
          if (onChange) onChange(e);
        }}
        disabled={disabled}
        ref={ref}
        data-recurly={dataRecurly}
      >
        {selectLabel && (
          <option value="" disabled>
            {selectLabel}
          </option>
        )}
        {map(list, (item) => (
          <option key={item.id || item.value} value={item.id || item.value}>
            {item.name ? item.name : item.displayName}
          </option>
        ))}
      </select>
      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
};

export default AdminSelect;
